import { isEmpty } from 'ramda';
import { IAddressSuggest, IMultiSuggestResult, IResultSuggestions } from '@cian/geosuggest-widget';

import { loadYmapsApi } from '../../services/ymaps';
import { MCS_NAME } from '../../constants/mcsName';
import { TThunkAction } from '../../types/redux';
import { YandexMonitor, YandexScriptError } from '../../utils/yandexMonitor';

export interface IYandexSuggestParams {
  request: string;
  addressType?: EAddressType;
}

export enum EAddressType {
  street = 'street',
  house = 'house',
}

/** Если тип адреса "Дом", то логгер будет отправлять error. В остальных случаях будет warning */
export const getYMonitorLoggerStrictness = (addressType?: EAddressType): boolean => {
  switch (addressType) {
    case EAddressType.house:
      return true;
    default:
      return false;
  }
};

export const getYandexSuggest = (params: IYandexSuggestParams): TThunkAction<Promise<IMultiSuggestResult>> => {
  return async () => {
    const { addressType, request } = params;

    const defaultData = {
      sortOrder: [],
      suggestions: {
        addresses: [],
      },
    };

    let yaSuggestResult: YMaps.ISuggestResult[] | YMaps.IScriptError | null = null;
    const suggestions: IResultSuggestions = {};

    const yandexSuggestApi = await loadYmapsApi({ require: ['suggest'] });

    const yMonitor = new YandexMonitor({
      isStrict: getYMonitorLoggerStrictness(addressType),
      mcsName: MCS_NAME,
    });

    try {
      yaSuggestResult = await yandexSuggestApi.suggest(`Россия, ${request}`);

      /** Ошибку можно поймать, отрубив интернет */
      if ('message' in yaSuggestResult) {
        throw new YandexScriptError();
      }

      yMonitor.sendTelemetryCounter();
      yMonitor.sendTelemetryTimer();
    } catch (e) {
      yMonitor.log(e);

      return defaultData;
    }

    if (!isEmpty(yaSuggestResult)) {
      suggestions.addresses = yaSuggestResult as IAddressSuggest[];
    }

    return {
      suggestions,
      sortOrder: ['addresses'],
    };
  };
};
